import { RootAppState } from 'store/configureStore'

export const projectSurchargeValueSelector = (state: RootAppState) => {
  if (state.project.activeProject?.financial?.surchargeValueOfItems == null) {
    return null
  }
  return state.project.activeProject?.financial.surchargeValueOfItems
}
